module.exports = __webpack_public_path__ + "static/logo.white-a58039ca4a82a5fa0717c6e05c4ecc81.svg";